import * as React from 'react'
import { Alert, Button, Form, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginAPI from 'api/login'
import { Status } from 'api/common/statuses'
import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import InputField from 'components/InputField'
import InputFieldPassword from 'components/InputFieldPassword'
import iconCaution from 'images/icon_caution.svg'
import { scrollToAnchor } from 'utilities/helper'
import { loginFormItems } from 'utilities/resources/formItems'
import { LoginFormValues } from 'utilities/resources/formItemValues'
import { PropertySetter } from 'utilities/typeUtility'
import { emailValidator, emptyValidator, ErrorChecker, FormErrorMessage } from 'utilities/validators'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [information, setInformation] = React.useState('')
  const [committed, setCommitted] = React.useState(false)
  const [formValues, setFormValues] = React.useState<LoginFormValues>({
    email: '',
    password: '',
  })
  const setter = new PropertySetter(setFormValues)
  const [errorValues, setErrorValues] = React.useState<FormErrorMessage<LoginFormValues>>()
  const errorChecker = new ErrorChecker<LoginFormValues>(loginFormItems)

  /**
   * 「ログイン」ボタン
   */
  const handleLogin = () => {
    errorChecker.init()
    errorChecker.check(emailValidator(formValues?.email), 'email')
    errorChecker.check(emptyValidator(formValues?.password), 'password')
    setErrorValues(errorChecker.getErrorMessageData())
    if (errorChecker.isValid()) {
      setCommitted(true)
      const email = formValues.email ?? ''
      const password = formValues.password ?? ''
      loginAPI({ email, password }, (status: Status, nextScene: string | null) => {
        switch (status) {
          case Status.Success: {
            if (nextScene) {
              localStorage.setItem('email', email)
              navigate(nextScene)
            }
            break
          }
          default: {
            setCommitted(false)
            setInformation('メールアドレス、パスワードのいずれかが間違っています。再度入力してください。')
            break
          }
        }
      })
    } else {
      scrollToAnchor(errorChecker.getFirstInvalidItemId())
    }
  }

  return (
    <>
      <HeaderLarge title="ログイン" />
      {information && (
        <Alert variant="danger" className="note text-justify border-0 mb-5">
          <div className="text-center">
            <img src={iconCaution} alt="caution" />
          </div>
          <div className="mt-2">{information}</div>
        </Alert>
      )}
      <Form>
        <InputField
          name={loginFormItems.email.name}
          labelTop={loginFormItems.email.label}
          type="email"
          bold
          placeholder="Emailアドレスを入れてください"
          onChange={(e) => setter.set('email', e)}
          errors={[errorValues?.email ?? '']}
        />
        <InputFieldPassword
          name={loginFormItems.password.name}
          label={loginFormItems.password.label}
          type="password"
          bold
          placeholder="パスワードを入れてください"
          className="mt-4"
          onChange={(e) => setter.set('password', e)}
          errors={[errorValues?.password ?? '']}
        />
        <div className="mt-5">
          <Button variant="primary" className="w-100 py-4" onClick={handleLogin} disabled={committed}>
            <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!committed} />
            ログイン
          </Button>
        </div>
      </Form>
      <div className="mt-5 text-end">
        <Button variant="link" href="/passwordReset">
          パスワードを忘れた方はこちら
        </Button>
      </div>
      <div className="mt-5">
        <Button variant="success" className="w-100 py-4" href="/contactUs">
          お問い合わせ
        </Button>
      </div>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
